import { useAtomValue } from 'jotai';
import { BasicDialog } from '../../../components/Dialog/BasicDialog';
import { GenericFallbacksWrapper } from '../../../components/Fallback/GenericFallbacksWrapper';
import { IField } from '../../../data-models/field2.data-model';
import { showKpiConfigFormAtom, useResetKpiConfigFormState } from './kpi-config-form-state';
import { KpiConfigForm } from './KpiConfigForm';

type KpiConfigFormDialogProps = {
  title: string;
  onSubmit?: (data: IField<unknown>) => void;
  defaultValues?: Partial<IField<unknown>>;
};
export function KpiConfigFormDialog({ title, onSubmit, defaultValues }: KpiConfigFormDialogProps) {
  const open = useAtomValue(showKpiConfigFormAtom);
  const onClose = useResetKpiConfigFormState();
  if (!open) {
    return null;
  }
  return (
    <BasicDialog open={open} onClose={onClose} title={title}>
      <GenericFallbacksWrapper>
        <KpiConfigForm defaultValues={defaultValues} onSubmit={onSubmit} />
      </GenericFallbacksWrapper>
    </BasicDialog>
  );
}
